import { useRouter } from 'next/router'
import React, { Fragment } from 'react'

import { UseFormReturn } from 'react-hook-form'

import { DeviceOrderData } from '@/lib/schemes'
import { Device, OrderEstimate } from '@/lib/types'
import { formatCurrency } from '@/lib/utils'

import { useOrderTotalInfo } from '@/hooks/shop/useOrderTotalInfo'

import Rule from '@/components/Rule'

const OrderTotalInfo = ({
  device,
  form,
  estimate,
  isLoading
}: {
  form: UseFormReturn<DeviceOrderData>
  device: Device
  estimate?: OrderEstimate
  isLoading: boolean
}) => {
  const { locale } = useRouter()

  const { totalOrderInfo } = useOrderTotalInfo({
    form,
    device,
    estimate,
    isLoading
  })
  const { currency } = device

  return (
    <div className="flex flex-col gap-2.5">
      <Rule className="border-[0.5px]" />
      {totalOrderInfo.map(({ name, count, amount }, index) => (
        <Fragment key={index}>
          <div className="flex items-center justify-between">
            <span>{name}</span>
            <div className="flex items-center gap-2">
              <span className="flex min-w-[80px] items-center justify-center">
                {count}
              </span>
              <span className="min-w-[100px] text-right font-medium">
                {typeof amount !== 'number'
                  ? amount
                  : !!amount && formatCurrency(amount, currency, locale)}
              </span>
            </div>
          </div>
          {index < totalOrderInfo.length - 1 && (
            <Rule className="border-[0.5px]" />
          )}
        </Fragment>
      ))}
    </div>
  )
}

export default OrderTotalInfo
